<template>
  <div class="grid-default container py-6 lg:py-24">
    <div class="col-span-6 lg:col-span-6">
      <Heading :level="1" class="mb-4 text-5xl font-light text-blue lg:mb-0 lg:text-9xl">
        {{ data.title }}
      </Heading>
    </div>
    <div
      v-if="data.html"
      class="col-span-6 text-base text-neutral-500 lg:text-2xl"
      v-html="data.html"
    ></div>
  </div>
</template>

<script setup lang="ts">
import { useAppStore } from '~/stores/AppStore'
import type { SectionTitleRecord } from '~/types/generated'
const store = useAppStore()

defineProps({
  data: {
    type: Object as PropType<SectionTitleRecord>,
    default: () => {}
  }
})

onMounted(() => {
  store.setTheme('white')
})
</script>
